import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { CompanyService } from '../../../services/company.service';
import { NtCompany } from '../models/nt-company';

@Directive({
  selector: '[appCompanyDynFieldLabel]'
})
export class CompanyDynFieldLabelDirective implements OnInit {
    @Input('fieldName') field = 'class';
    
    constructor(private comp: CompanyService,
        private eRef: ElementRef) { }

    ngOnInit(): void {
        this.comp.SelectedCompany.pipe(take(1))
            .subscribe(comp => {
                if(!comp){
                    return;
                }

                let textResult = '';
                const field = this.field.toLowerCase();
                if(field === 'class'){
                    textResult = NtCompany.GetProviderClassLabel(comp.externalDataSource.dataSource);
                }else{
                    textResult = NtCompany.GetProviderLocationLabel(comp.externalDataSource.dataSource, comp.useProviderLocation);
                }

                this.eRef.nativeElement.innerText = textResult;
            }
        );
    }

}